<div class="db-settings__default-mode">

  <div class="db-settings__default-mode-header" [ngClass]="{'test-mode-enabled': testModeEnabled}">
    <div [ngClass]="{'ds-lazy-load': boosterModeLoading || testModeLoading}" *ngIf="(boosterPluginIsActive || boosterPluginIsOld)">
      <h2 class="mb4">{{testModeEnabled ? (companyName + ' ' + ('text_companyBoosterActive' | dbText)) : ((userSubscription?.paidClient || !!websiteHosted) ? (companyName + ' ' + ('text_companyBoosterActive' | dbText)) : (companyName + ' ' + ('text_companyBoosterActive' | dbText)))}}</h2>
      <div>
        <p *ngIf="!(userSubscription?.paidClient || !!websiteHosted)">
          <i class="db-icon db-icon-ds-checkmark-bg mr4"></i>
          <span [innerHTML]="'text_optimizationLevel' | dbText: {level: boosterMode}"></span>
        </p>
        <p class="mt6" *ngIf="!(userSubscription?.paidClient || !!websiteHosted)">
          <i class="db-icon db-icon-ds-checkmark-bg mr4"></i>
          <span>Homepage is optimized</span>
        </p>
        <p class="mt6" *ngIf="(userSubscription?.paidClient || !!websiteHosted)">
          <i class="db-icon db-icon-ds-checkmark-bg mr4"></i>
          <span [innerHTML]="'text_optimizationLevel' | dbText: {level: cdnStatus === 'active' && userSubscription?.boosterProClient ? boosterMode + ' + CDN' : boosterMode}"></span>
        </p>
        <p class="mt6">
          <i class="db-icon db-icon-{{testModeEnabled ? 'ds-info-bg' : 'ds-checkmark-bg'}} mr4"></i>
          <span>{{testModeEnabled ? ('text_pageCacheDisabled' | dbText) : ('text_cachingEnabled' | dbText) }}</span>
        </p>
        <p class="mt6" *ngIf="userSubscription?.trialBoosterClient && notOptimizedPagesCount > 0">
          <i class="db-icon db-icon-ds-info-bg yellow mr4"></i>
          <span>{{ notOptimizedPagesCount === 1 ? notOptimizedPagesCount + ' page is not optimized' : notOptimizedPagesCount + ' pages are not optimized'}}</span>
        </p>
        <p class="mt6" *ngIf="(userSubscription?.paidClient || !!websiteHosted)">
          <i class="db-icon db-icon-ds-checkmark-bg mr4"></i>
          <span>{{'text_newPagesOptimizedAuto' | dbText}}</span>
        </p>
      </div>
    </div>
    <div class="db-settings__booster-activation-banner"
         [ngClass]="{'ds-lazy-load': boosterModeLoading || testModeLoading}" *ngIf="!boosterPluginIsActive && !boosterPluginIsOld">
      <div>
        <h2 class="mb2">{{companyName}} Booster is not active</h2>
        <p>Go a step further and optimize your entire website, not just images.</p>
      </div>
      <div class="db-booster-activation-banner__button">
        <a class="ds-btn-green ds-btn-m" (click)="getWpImageOptimizerPage()">
          <span [innerHTML]="'text_activateBooster' | dbText | lowerCaseSpecificWords"></span>
        </a>
      </div>
    </div>
    <div class="db-settings__current-mode" *ngIf="!!testModeEnabled"
         [ngClass]="{'ds-lazy-load': boosterModeLoading || testModeLoading, 'test-mode-enabled': testModeEnabled, 'free': userSubscription?.trialBoosterClient}">
      <p [innerHTML]="'text_websiteTestMode' | dbText"></p>
      <div class="db-switch-wrap">
        <input id="test-mode-switcher" class="ds-switcher-green ds-control-small" type="checkbox"
               (change)="disableTestMode()"  value="'true'" [checked]="true">
        <label for="test-mode-switcher">
          <span class="ds-switcher-control"></span>
        </label>
      </div>
    </div>
  </div>
  <div>
    <div class="db-settings__options mt30">
      <div class="db-settings__default-mode-options"
           *ngFor="let option of  settingsOptions?.slice(0, 4); let i = index"
           [ngClass]="{ 'disabled': !boosterPluginIsActive && !boosterPluginIsOld,
            'active': option?.id === boosterMode && !(userSubscription?.boosterProClient && cdnStatus === 'active'),
            'ds-lazy-load': boosterModeLoading || testModeLoading,
            'test-mode-enabled': testModeEnabled}">
        <div class="db-settings__default-mode-options-select">

        <!--  <i *ngIf="option?.id === 'pro' && cdnStatus !== 'active'" class="db-icon db-icon-ds-diamond"></i>
          <span *ngIf="option?.id === 'pro' && cdnStatus === 'active'" class="db-website-item-menu__checkmark-container"> <i
            class="db-icon db-icon-ds-circle-filled"></i> </span>-->


          <div class="db-settings__default-mode-info">
            <p>
              <b [innerHTML]="option.title | dbText"></b>
              <ng-container
                *ngFor="let opt of (userSubscription?.boosterProClient || userSubscription?.trialBoosterClient ? settingsOptions : settingsOptions?.slice(0, 4)); let i = index">
                <i class="db-icon db-icon-circle-sm {{option?.key >= opt?.key ? opt?.id : ''}}"
                   [ngClass]="{'ml10': i === 0}"></i>
              </ng-container>
            </p>
            <p *ngIf="option?.id !== 'pro'" class="mt4" [innerHTML]="option.desc | dbText"></p>
            <p *ngIf="option?.id === 'pro'" class="link"
               [ngClass]="{'pro': userSubscription?.boosterProClient,
               'capitalize': !(userSubscription?.trialBoosterClient || (!!websiteHosted && cdnStatus !== 'active'))}"
               [innerHTML]="userSubscription?.trialBoosterClient || (!!websiteHosted && cdnStatus !== 'active') ? 'Apply now' : this.boosterMode + ' +' + '<br>CDN'"></p>
          </div>
        </div>
        <div class="db-settings__overlay" *ngIf="(!loadingApply || !!websiteHosted || (loadingApply && option?.id === boosterMode)) && (boosterPluginIsActive || boosterPluginIsOld)"
             [ngClass]="{'show': loadingApply && option?.id === boosterMode}">
          <a *ngIf="option?.id !== 'pro'" class="ds-btn{{!testModeEnabled ? '-green' : ''}} ds-btn-small rectangle"
             (click)="selectMode(option?.id)" [ngClass]="{'ds-btn-disabled': loadingApply}">
            <span *ngIf="!loadingApply">{{'text_apply' | dbText}}</span>
            <db-loading-circular-spinner *ngIf="loadingApply"></db-loading-circular-spinner>
          </a>
          <a *ngIf="option?.id === 'pro'"
             class="ds-btn{{!testModeEnabled ? userSubscription?.trialBoosterClient ? '-white' : '-green' : ''}} ds-btn-small rectangle"
             (click)="
             userSubscription?.trialBoosterClient ? showUpgradeDialog() :
             (userSubscription?.boosterProClient || !!websiteHosted) && cdnStatus !== 'active' ? showActivateCDN() : null"
             [ngClass]="{'ds-btn-disabled': loadingApply }">
            <span *ngIf="!loadingApply">{{'text_apply' | dbText}}</span>
            <db-loading-circular-spinner *ngIf="loadingApply"></db-loading-circular-spinner>
          </a>
        </div>
        <!--<p class="db-settings__mode-preview">
          <a target="_blank" [href]="websiteUrl + '?two_mode=' + option?.id">Preview</a>
        </p>-->
      </div>
    </div>
  </div>

</div>
